import React from "react"
import { FaSpinner } from "react-icons/fa"
import "./Spinner.css"

export default function Spinner(props) {




  return <FaSpinner style={{ color: '#fff' }} className="fontSpinner" />
}






